/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_Manage_LabelInputs */



/**
* | output |
* | --- |
* | "Open speaker manager" |
*
* @param {Insert_Speaker_Manage_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_manage_label = /** @type {((inputs?: Insert_Speaker_Manage_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_Manage_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir le gestionnaire de locuteurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Open Speaker Manager")
	if (locale === "it") return /** @type {LocalizedString} */ ("Responsabile degli oratori aperti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Менеджер открытых выступлений")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gestor de oradores abierto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开放式演讲者管理")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーマネージャーを開く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओपन स्पीकर मैनेजर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerente de palestrantes aberto")
	return /** @type {LocalizedString} */ ("Open speaker manager")
});